import { Typography } from "@material-ui/core";
import React from "react";
import clsx from "clsx";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import BatchSummary from "components/BatchSummary/BatchSummary";
import { ReactComponent as RedXMark } from "icons/RedXMark.svg";
import { ReactComponent as EventGreenCheckMark } from "icons/EventGreenCheckMark.svg";
import { AssessmentStatus } from "models/thorEventModels/BatchImpactAssessment";
import { observer } from "mobx-react";
import { useStore } from "store/StoreConfigs";
import { ImpactDecisionRecommendationProps } from "./ImpactDecisionRecommendationProps";
import { impactDecisionRecommendationStyles } from "./ImpactDecisionRecommendationStyles";

export default observer(function ImpactDecisionRecommendation({
    recommendationDecision,
    assessmentStatusId,
    batchId,
    decision,
}: ImpactDecisionRecommendationProps) {
    const { thorEventViewStore } = useStore();
    const classes = impactDecisionRecommendationStyles();

    const message = thorEventViewStore.eventSummary.batchSummaries
        .find((decision) => decision.batchId === batchId)!
        .impactDecision.message.split("\n");
    return (
        <>
            <Typography
                className={clsx(classes.message, {
                    [classes.supported]: recommendationDecision,
                    [classes.notSupported]: !recommendationDecision,
                })}
            >
                {recommendationDecision ? (
                    <>
                        <EventGreenCheckMark className={classes.iconDown} />
                        Excursion is supported
                    </>
                ) : (
                    <>
                        <RedXMark className={classes.iconUp} />
                        Excursion is not supported
                    </>
                )}
            </Typography>

            {(assessmentStatusId === AssessmentStatus.PendingReview ||
                assessmentStatusId === AssessmentStatus.PendingDecision ||
                assessmentStatusId === AssessmentStatus.ReAssessing) && (
                <Typography className={classes.recommendation}>{message}</Typography>
            )}

            {assessmentStatusId === AssessmentStatus.EvaluationCompleted &&
                (thorEventViewStore.isEventSummaryLoaded ? (
                    <div className={classes.smallIndicator}>
                        <LoadingIndicator />
                    </div>
                ) : (
                    <BatchSummary batchId={batchId} decision={decision} />
                ))}
        </>
    );
});
